import { useOnboarding } from '../onboarding/hooks/useOnboarding';
import { OnboardingLayout } from '../onboarding/components/OnboardingLayout';
import { OnboardingStep } from '../onboarding/components/OnboardingStep';

import { StepUsage } from '../onboarding/steps/StepUsage';
import { StepManage } from '../onboarding/steps/StepManage';
import { StepOrgName } from '../onboarding/steps/StepOrgName';
import { StepFeatures } from '../onboarding/steps/StepFeatures';
import { StepTaskOrganization } from '../onboarding/steps/StepTaskOrganization';
import { StepInviteMembers } from '../onboarding/steps/StepInviteMembers';
import { useTranslation } from 'react-i18next';
import { FeatureErrorBoundary } from '@/core/error-boundaries/public';
import { sentryReporter } from '@/core/observability/public';

const STEP_COMPONENTS = {
  usage: StepUsage,
  manage: StepManage,
  orgName: StepOrgName,
  features: StepFeatures,
  taskOrganization: StepTaskOrganization,
  inviteMembers: StepInviteMembers,
};

export function OnboardingPage() {
  const { t } = useTranslation('onboarding');
  const {
    stepTitle,
    step,
    answers,
    progress,
    isPending,
    isError,
    error,
    isFirstStep,
    isLastStep,
    canGoNext,
    user,
    setAnswer,
    goNext,
    goBack,
    skipStep,
  } = useOnboarding();

  const StepComponent = STEP_COMPONENTS[step.id];

  return (
    <FeatureErrorBoundary reporter={sentryReporter}>
      <OnboardingLayout
        user={user}
        progress={progress}
        isFirstStep={isFirstStep}
        isLastStep={isLastStep}
        canGoNext={canGoNext}
        isPending={isPending}
        optional={step.optional}
        onBack={goBack}
        onNext={goNext}
        onSkip={skipStep}
      >
        <OnboardingStep title={stepTitle}>
          {isError && (
            <p className="text-sm text-destructive mb-4" data-testid="onboarding-page-error">
              {error?.message ?? t('error')}
            </p>
          )}

          <StepComponent answers={answers} setAnswer={setAnswer} />
        </OnboardingStep>
      </OnboardingLayout>
    </FeatureErrorBoundary>
  );
}
